import api from 'api';
import { actions } from 'store';
import { useDispatch, useReduxState } from 'hooks';
import { ModalButtonWithForm } from 'components/common';
import { Switch } from 'components/common/form';

interface Props {
  attributes: any;
  updateData: () => Promise<void>;
}

const UserAttributesEnable = ({ attributes, updateData }: Props) => {
  const { dispatch } = useDispatch();

  const { messages, theme } = useReduxState();

  const handleSubmit = async ({ attributesData }) => {
    for (const attribute of attributes) {
      const data = { isEnabled: attributesData?.[attribute.id]?.isEnabled };
      await api.put(`/admin/user-custom-attributes/${attribute.id}`, data);
    }

    await updateData();

    dispatch(
      actions.addNotice({
        text: 'Attributes updates successfully',
        type: 'success'
      })
    );
  };

  const attributesData = {};
  attributes.forEach((attribute) => {
    attributesData[attribute.id] = {
      isEnabled: attribute.isEnabled
    };
  });

  const initialValues = {
    attributesData
  };

  return (
    <ModalButtonWithForm
      buttonCategory="light"
      buttonDisabled={!attributes}
      buttonIcon="check"
      buttonIsDropdown={true}
      buttonSize="header"
      buttonText={'Enable or disable'}
      contentStyle={{ padding: 0 }}
      initialValues={initialValues}
      modalActionCategory="success"
      modalActionText={messages.commonSaveChanges}
      modalTitle={'Enable or disable attributes'}
      modalWidth="medium"
      onSubmit={handleSubmit}
      pristineIsValid={false}
    >
      {() => (
        <div className="attributes">
          {attributes?.map((attribute) => (
            <div className="attribute" key={attribute.id}>
              <div className="title">
                {attribute.title}
                <div className="subtitle">
                  {`${messages.attributesKey}: ${attribute.key}`}
                </div>
              </div>

              <div className="enabled">
                <Switch
                  field={`attributesData.${attribute.id}.isEnabled`}
                  id={`attributes-enable-attribute-${attribute.id}`}
                  label={messages.commonEnabled}
                />
              </div>
            </div>
          ))}

          <style jsx>{`
            .attribute {
              align-items: center;
              display: flex;
              gap: 30px;
              justify-content: space-between;
              padding: 10px 15px;
            }
            .attribute:not(:first-child) {
              border-top: 1px solid ${theme.lightGrey};
            }
            .title {
              color: ${theme.textColorLight};
              font-size: 1.5rem;
              font-weight: 600;
            }
            .subtitle {
              color: ${theme.textColorLighter};
              font-size: 1.2rem;
              font-weight: 400;
              white-space: nowrap;
            }
          `}</style>
        </div>
      )}
    </ModalButtonWithForm>
  );
};

export default UserAttributesEnable;
